import React, { useState } from "react";
import { ButtonSpinner, errorMessageHandler } from "../../../utils/utils";
import { useSelector, useDispatch } from "react-redux";
import MnemonicsConfirmationModal from "../../CreateNFT/SingleNFT/MnemonicsConfirmationModal";
import { setCypherSecret } from "../../../actions/auth";
import ContinueWithPassword from "../../CreateNFT/SingleNFT/ContinueWithPassword";
import CryptoJS from 'crypto-js';
import { placeOrder, purchaseNft, transferNft } from "../../../api/nft/nft";
import MissingMnemonics from "../../Layouts/MissingMnemonics/MissingMnemonics";

const BuyNft = ({ isOpen, onClose, id, onSuccess, nftDetailObject }) => {
   

    // 📦 Form state
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [passwordModal, setShowPasswordModal] = useState(false);
    const [mnemonicsConfirmationModal, setShowMnemonicsConfirmationModal] = useState(false);
    const dispatch = useDispatch();
    const currentUser = useSelector((state) => state.Profile.profile);
    const cypherSecret = useSelector((state) => state.Auth.cypherSecret);
    const balances = useSelector((state) => state.Wallet.balances);
    // Get price from nftDetailObject
    const price = nftDetailObject?.price || nftDetailObject?.nft_price || 0;
   



    // 🚀 Handle confirmation (Yes button)
    const handleConfirm = async () => {
        // Check if user has NOT set up their wallet (public address)
        if (!currentUser.public_address) {
            handleClose(true)
            return
            //  return document.getElementById('confirmationMissingMnemonicsBtn').click();

        }

        // Show appropriate modal based on whether user has saved mnemonics
        if (cypherSecret) {
            setShowPasswordModal(true)
        }
        else {
            setShowMnemonicsConfirmationModal(true)
        }
    };

    const handleTransferNft = (mnemonics, publicAddress, saveMyMnemonics, mnemonicsPwd) => {
        if (!mnemonics) {

            setErrors(prev => ({
                ...prev,
                submit: "Mnemonics are required."
            }));
            return;
        }

        if (!publicAddress) {
            setErrors(prev => ({
                ...prev,
                submit: "Your profile address does not match the provided mnemonics. Please use the mnemonics you provided during sign-up.",
            }));

            return;
        }

        if (publicAddress.toLowerCase() !== currentUser?.public_address?.toLowerCase()) {
            setErrors(prev => ({
                ...prev,
                submit: "Your profile address does not match the provided mnemonics. Please use the mnemonics you provided during sign-up.",
            }));
            return;
        }
        if (parseFloat(balances.NUC) <= 0) {
            setErrors(prev => ({
                ...prev,
                submit: "Balance should be greater than 0. Currently, you have 0 balance."
            }));
        }

        // ✅ All good — process NFT minting
        processNft(mnemonics, saveMyMnemonics, mnemonicsPwd);
    };

    let processNft = async (mnemonics, saveMyMnemonics, mnemonicsPwd) => {
        if (saveMyMnemonics) {
            const cypher = CryptoJS.AES.encrypt(mnemonics, mnemonicsPwd).toString();
            dispatch(setCypherSecret(cypher));
        }

        try {
            setIsLoading(true)
            setErrors({})
            let { data } = await purchaseNft({ nftId: id, orderId: nftDetailObject?.openOrder?._id, secret: mnemonics })
            onSuccess(nftDetailObject.openOrder.price, data.data.txHash)
            handleClose()
            setIsLoading(false)
        } catch (error) {
            console.error("Transfer error:", error);
            setErrors(prev => ({
                ...prev,
                submit: errorMessageHandler(error)
            }));
        } finally {
            setIsLoading(false);
        }
    }


    // 🔒 Handle modal close
    const handleClose = (result = false) => {
        setErrors({});
        setIsLoading(false);
        onClose(result);
    };

    if (!isOpen) return null;

    return (
        <>
         
            {/* Modal Backdrop */}
            <div
                className="modal-backdrop fade show"
                onClick={handleClose}
                style={{ zIndex: 1040 }}
            ></div>

            {/* Modal */}
            <div
                className="modal fade show"
                id="transferModalDesign"
                tabIndex="-1"
                aria-labelledby="transferModalDesignLabel"
                aria-modal="true"
                role="dialog"
                style={{ display: 'block', zIndex: 1050 }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content NFTDetailDesign__modal">
                        <div className="modal-header border-0 pb-0">
                            <h5 className="modal-title w-100 text-center" id="transferModalDesignLabel">
                                Confirm Purchase
                            </h5>
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close" />
                        </div>
                        <div className="modal-body text-center py-4">
                            {/* Confirmation Icon */}
                            <div className="mb-4">
                                <i className="bi bi-question-circle" style={{ fontSize: '4rem', color: '#6c757d' }}></i>
                            </div>

                            {/* Confirmation Message */}
                            <h5 className="mb-3">Are you sure you want to buy this NFT?</h5>

                            {/* Price Display */}
                            <div className="bg-light rounded p-3 mb-3">
                                <p className="text-muted mb-1">Price</p>
                                <h3 className="mb-0 fw-bold">{nftDetailObject?.openOrder?.price} <span className="text-muted fs-5">NUC</span></h3>
                            </div>

                            {/* ⚠️ Submit Error */}
                            {errors.submit && (
                                <div className="alert alert-danger text-start" role="alert">
                                    <i className="bi bi-exclamation-triangle me-2"></i>
                                    {errors.submit}
                                </div>
                            )}
                        </div>
                        <div className="modal-footer border-0 justify-content-center pt-0">
                            <button
                                type="button"
                                className="btn btn-outline-secondary px-4"
                                onClick={handleClose}
                                disabled={isLoading}
                                style={{ minWidth: '120px' }}
                            >
                                <i className="bi bi-x-circle me-2"></i>
                                No
                            </button>
                            <button
                                type="button"
                                className="btn BtnBlack px-4"
                                style={{ opacity: isLoading === true ? 0.3 : 1, minWidth: '120px' }}
                                disabled={isLoading}
                                onClick={handleConfirm}
                            >
                                {isLoading ? (
                                    <>
                                        <ButtonSpinner />
                                        <span className="ms-2">Processing...</span>
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-check-circle me-2"></i>
                                        Yes
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <MnemonicsConfirmationModal
                visible={mnemonicsConfirmationModal}
                currentUser={currentUser}
                onClose={() => setShowMnemonicsConfirmationModal(false)}
                onConfirm={(data) => {
                    handleTransferNft(data.mnemonics, data.publicAddress, data.saveMyMnemonics, data.mnemonicsPwd)
                    setShowMnemonicsConfirmationModal(false);
                }}
            ></MnemonicsConfirmationModal>

            <ContinueWithPassword
                visible={passwordModal}
                currentUser={currentUser}
                cypherSecret={cypherSecret}
                onClose={() => setShowPasswordModal(false)}
                onConfirm={(data) => {
                    if (data.forgotPassword) {
                        setShowPasswordModal(false)
                        setShowMnemonicsConfirmationModal(true);
                    }
                    else {
                        handleTransferNft(data.mnemonics, data.publicAddress)
                        setShowPasswordModal(false)
                    }
                }}
            />
            <MissingMnemonics></MissingMnemonics>

        </>
    );
};


export default BuyNft;



